import styled from "styled-components";

import { NavLink } from "react-router-dom";

export const SideBarBody = styled.div`
   width: 8vh;
   display: block;
   flex-direction: column;
   padding-left: 15px;
   padding-right: 15px;
   list-style: none;
`;

export const SideBarFooter = styled.div`
   width: 8vh;
   display: block;
   flex-direction: column;
   padding-left: 15px;
   padding-right: 15px;
   list-style: none;
`;

export const Text = styled.text`
  opacity: 0%;
  display: none;
`;

export const NavLinks = styled(NavLink)`
   height: 45px;
   display: flex;
   color: #fff;
   position: relative;
   text-decoration: none;
   padding: 10px 0px 10px 0px;
   border-radius: 10px;
   margin-top: 20px;
   margin-bottom: 20px;
   &:hover {
      background: #1d2546;
   }
   &.active {
      background: #252f58;
   }
`;

export const NavBtn = styled.div`
   height: 45px;
   display: flex;
   color: #fff;
   position: relative;
   justify-content: space-between;
   text-decoration: none;
   padding: 10px 0px 10px 0px;
   border-radius: 10px;
   margin-top: 20px;
   margin-bottom: 20px;
   &:hover {
      background: #1d2546;
   }
`;

export const SubMenuBody = styled.div`
   display: block;
   flex-direction: column;
`;

export const SubMenu = styled(NavLink)`
   height: 45px;
   display: flex;
   color: #fff;
   position: relative;
   text-decoration: none;
   padding: 10px 0px 10px 0px;
   border-radius: 10px;
   margin-top: 20px;
   margin-bottom: 20px;
   &:hover {
      background: #1d2546;
   }
   &.active {
      background: #252f58;
   }
`;

export const SideBarWrapper = styled.div`
   width: 8vh;
   display: flex;
   align-items: center;
   flex-direction: column;
   justify-content: space-between;
   overflow: visible;
   padding-top: 20px;
   background-color: #171D37;
   &:hover {
     width: 22vh;
     transition: width 0.5s ease;
   }
   &:hover ${SideBarBody} {
     width: 22vh;
   }
   &:hover ${SideBarFooter} {
     width: 22vh;
   }
   &:hover ${Text} {
     opacity: 100%;
     display: contents;
     position: relative;
   }   
`;